import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {v4 as uuidv4} from "uuid";
import {PublicInformationItem} from "../types/pyblicInformation";

const COLLECTION_ID = "686291930035d8da3991"

const databases = new Databases(client);

export const publicInformationService = {

  async list(queries: string[] = [], limit: number = 100): Promise<PublicInformationItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const items = response.documents.map(doc => doc as unknown as PublicInformationItem);
      return items;
    } catch (error) {
      throw error;
    }
  },

  async create(data: PublicInformationItem): Promise<PublicInformationItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as PublicInformationItem;

      return createdItem;
    } catch (error) {

      throw error;
    }
  },
  async update(data: PublicInformationItem): Promise<PublicInformationItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        COLLECTION_ID,
        id,
        correctData
      ) as unknown as PublicInformationItem;

      return updatedItem;
    } catch (error) {
      throw error;
    }
  },
  async getById(id: string): Promise<PublicInformationItem> {
    try {
      const data = await databases.getDocument(
        database_id,
        COLLECTION_ID,
        id
      ) as unknown as PublicInformationItem;
      return data
    } catch (error) {
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        COLLECTION_ID,
        id
      );
    } catch (error) {
      throw error;
    }
  },
}